import { render, staticRenderFns } from "./SurgeonGeneralsWarning.vue?vue&type=template&id=67f0de0f&scoped=true"
import script from "./SurgeonGeneralsWarning.vue?vue&type=script&lang=js"
export * from "./SurgeonGeneralsWarning.vue?vue&type=script&lang=js"
import style0 from "./SurgeonGeneralsWarning.vue?vue&type=style&index=0&id=67f0de0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f0de0f",
  null
  
)

export default component.exports